import React, {
  createContext,
  type ReactNode,
  useContext,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";
import { type ModalData } from "types/modal";

// Define the shape of the context value
export interface ModalContextType {
  data: ModalData;
  open: Dispatch<SetStateAction<ModalData>>;
  closeIntercept: () => void;
}

const Context = createContext<ModalContextType | undefined>(undefined);

// Custom hook with safety check
export const useModalContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      "useModalContext must be used within a ModalContext provider",
    );
  }
  return context;
};

// Props for the provider
interface ModalProviderProps {
  children: ReactNode;
}

export const ModalContext = ({ children }: ModalProviderProps) => {
  const [modalData, openModal] = useState<ModalData>({
    isOpen: false,
    isClosable: true,
    showCloseButton: false,
    variant: null,
    link: null,
    vimeoLink: null,
    copy: null,
    buttons: null,
    header: null,
  });

  const interceptStorageKey = "hcp-intercept-confirmed";

  const closeIntercept = () => {
    openModal({
      isOpen: false,
    });

    localStorage.setItem(interceptStorageKey, "true");
  };

  return (
    <Context.Provider
      value={{
        data: modalData,
        open: openModal,
        closeIntercept: closeIntercept,
      }}
    >
      {children}
    </Context.Provider>
  );
};
